
import DrawBase from "../DrawBase"
import EditTriangle from "./EditTriangle"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawTriangle extends DrawBase {

    constructor(options) {
        super(options);
    }

    getTypeName() {
        return "三角形";
    }

    getType() {
        return "triangle_Nor";
    }

    getEditInterface() {
        return EditTriangle;
    }


    checkLeftClick() {
        if (this.positionsTemp.length <= 2) {
            return true;
        }
        return false;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
                return new $this.Cesium.PolygonHierarchy(positionsArr);
            }
            return new $this.Cesium.PolygonHierarchy(positionsArr ? positionsArr : $this.positions);
        }, false);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
    }


    loadDynamicGraph(entity, data) {
        var $this = this;
        var positionsArr =  JSON.parse(data.editPositions);;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy(positionsArr);
        }, true);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polygon")
    }

}

export default DrawTriangle;